import React from 'react';
import BotoneraDesplegable from '../UI/BotoneraDesplegable';
import ListaPaisesConfederacion from './ListaPaisesConfederacion';
import * as Confederaciones from "../constantes/Confederaciones.js";

const botones = [
  Confederaciones.CONMEBOL,
  Confederaciones.UEFA,
  Confederaciones.CONCACAF,
  Confederaciones.CAF,
  Confederaciones.AFC,
  Confederaciones.OFC,
];
  
const BotoneraConfederaciones = (props) => {
  const pathLinks = props.pathLinks;

  return (
    <BotoneraDesplegable
      lista={botones}
      renderBody={(item) => <ListaPaisesConfederacion confederacion={item} pathLinks={pathLinks} />}
      desplegarPrimero={false}
    />
  );
};

export default BotoneraConfederaciones;